// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_qq-5";
export var filledCircle = "_qq-4";
export var historyEntry = "_qq-3";
export var messageSideLeft = "_qq-1";
export var messageSideRight = "_qq-2";
export var orderTrackingCarouselWrapper = "_qq-6";
export var orderTrackingInfoContainer = "_qq-0";